import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: { marginTop: 32 },
    header: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
    },
    codeTextFieldSection: {
      marginTop: 32,
      display: "flex",
      flexDirection: "column",
    },
    codeTextFieldLabel: {
      alignSelf: "flex-start",
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
    },
    codeTextField: {
      width: "100%",
      marginTop: 8,
      textAlign: "left",
    },
    verifyButton: {
      marginTop: 32,
    },
    cancelButton: {
      marginTop: 32,
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
